export const wait = (ms: number) =>
  new Promise((r) => {
    setTimeout(() => r(undefined), ms);
  });
